var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whatsapp-c"},[_c('a',{attrs:{"href":"https://wa.link/axc3af","target":"_blank","rel":"noopener noreferrer"}},[_c('img',{attrs:{"src":require("../../assets/wasa.svg"),"alt":"wapp"}})])])
}]

export { render, staticRenderFns }